import React, { useEffect, useState } from 'react';

import { FileUploadField } from '../../../../components/FormFields';
import { useStateAuthValue } from '../../../../context/Auth/AuthState';

const ProfileSignPhotoForm = ({ formModel }) => {
   const {
      professional_dto: { sign_photo },
   } = formModel;

   const [{ userData }] = useStateAuthValue();
   const [professionalPhoto, setProfessionalPhoto] = useState();

   useEffect(() => {
      if (userData) {
         setProfessionalPhoto(userData.professional_dto?.sign_photo || '');
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [userData]);

   return (
      <>
         <div className="header">
            <h2>Firma de Profesional</h2>
         </div>
         <div className="form">
            <FileUploadField
               name={sign_photo.name}
               label={sign_photo.label}
               validation={sign_photo}
               savedFile={professionalPhoto}
               isImage
               className="field"
               requiredField
            />
         </div>
      </>
   );
};

export default ProfileSignPhotoForm;
